import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { AuthGuard } from './services/auth.guard';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ClinicsDataGuard } from './services/clinics-data.guard';
import { NewLeadComponent } from './pages/new-lead/new-lead.component';
import { SuccessPaymentComponent } from './pages/success-payment/success-payment.component';
import { ArDataResolverService } from './services/ar-data-resolver.service';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'sign-in',
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [
      AuthGuard,
    ],
  },
  {
    path: 'capturing/:clinicRefCode',
    canActivate: [
      ClinicsDataGuard,
    ],
    resolve: {
      arData: ArDataResolverService,
    },
    loadChildren: () => import('./features/capturing/capturing.module').then(m => m.CapturingModule),
  },
  {
    path: 'simulation/:patientRef',
    resolve: {
      arData: ArDataResolverService,
    },
    loadChildren: () => import('./features/simulation/simulation.module').then(m => m.SimulationModule),
  },
  {
    // TODO: can get rid of route with 'clinicRefCode' as now we have all info from patient response
    path: 'simulation/:clinicRefCode/:patientRef',
    canActivate: [
      ClinicsDataGuard,
    ],
    resolve: {
      arData: ArDataResolverService,
    },
    loadChildren: () => import('./features/simulation/simulation.module').then(m => m.SimulationModule),
  },
  {
    // new Clinic (as Lead) creation
    path: 'signup',
    component: NewLeadComponent,
  },
  {
    path: 'success',
    component: SuccessPaymentComponent,
  },
  {
    path: 'sign-in',
    component: LoginComponent,
  },
  {
    path: '404',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false, relativeLinkResolution: 'legacy'})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
